"use client";
import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Box } from "@mui/material";
import { Analytics } from "../../../../../Analytics/index.js";
import { FSAEligibleInfoUI } from "../../../../FSAEligibleInfo/FSAEligibleInfoUI/FSAEligibleInfoUI.js";
import { childElementStyles } from "../styles.js";
const FSAEligibleInfoWrapper = memo(
  ({ fsaConfig }) => {
    return /* @__PURE__ */ jsx(
      Analytics,
      {
        analyticData: {
          doNotTrack: true
        },
        children: /* @__PURE__ */ jsx(Box, { sx: childElementStyles, children: /* @__PURE__ */ jsx(FSAEligibleInfoUI, { data: fsaConfig }) })
      }
    );
  }
);
FSAEligibleInfoWrapper.displayName = "FSAEligibleInfoWrapper";
export {
  FSAEligibleInfoWrapper
};
